/**
 * @generated SignedSource<<3362e7425246630761069a715ecaaf70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FormResponseState = "DRAFT" | "SUBMITTED" | "%future added value";
export type MemberStatusValue = "DELETED" | "INVITED" | "PENDING_INVITATION" | "REGISTERED" | "%future added value";
export type RsvpState = "ATTENDING" | "DECLINED" | "MAYBE" | "NOT_RESPONDED" | "%future added value";
export type SignatureEnvelopeState = "CANCELLED" | "CERTIFYING" | "COMPLETED" | "COMPLETING" | "SIGNING" | "%future added value";
export type SignatureState = "REJECTED" | "SIGNED" | "WAITING" | "%future added value";
export type ReminderModal_node_Query$variables = {
  id: string;
};
export type ReminderModal_node_Query$data = {
  readonly node: {
    readonly __typename: string;
    readonly content?: {
      readonly __typename: "Form";
      readonly responses: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly responder: {
              readonly avatar: {
                readonly name: string | null;
                readonly url: URIString;
              } | null;
              readonly id: string;
              readonly name: string;
              readonly status: {
                readonly value: MemberStatusValue;
              } | null;
              readonly " $fragmentSpreads": FragmentRefs<"UserHandle_member">;
            };
            readonly state: FormResponseState;
          } | null;
        }>;
      };
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
    readonly id: string;
    readonly invitations?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly invitee: {
            readonly avatar: {
              readonly name: string | null;
              readonly url: URIString;
            } | null;
            readonly id: string;
            readonly name: string;
            readonly status: {
              readonly value: MemberStatusValue;
            } | null;
            readonly " $fragmentSpreads": FragmentRefs<"UserHandle_member">;
          };
          readonly rsvp: RsvpState;
        } | null;
      }>;
    } | null;
    readonly ownershipEvent?: {
      readonly id: string;
      readonly invitations: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly invitee: {
              readonly avatar: {
                readonly name: string | null;
                readonly url: URIString;
              } | null;
              readonly id: string;
              readonly name: string;
              readonly status: {
                readonly value: MemberStatusValue;
              } | null;
              readonly " $fragmentSpreads": FragmentRefs<"UserHandle_member">;
            };
            readonly rsvp: RsvpState;
          } | null;
        }>;
      } | null;
    } | null;
    readonly signatureEnvelope?: {
      readonly id: string;
      readonly signatures: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly member: {
              readonly avatar: {
                readonly name: string | null;
                readonly url: URIString;
              } | null;
              readonly id: string;
              readonly name: string;
              readonly status: {
                readonly value: MemberStatusValue;
              } | null;
              readonly " $fragmentSpreads": FragmentRefs<"UserHandle_member">;
            };
            readonly status: SignatureState;
          } | null;
        }>;
      };
      readonly status: SignatureEnvelopeState;
    } | null;
    readonly space?: {
      readonly memberships: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly member: {
              readonly avatar: {
                readonly name: string | null;
                readonly url: URIString;
              } | null;
              readonly id: string;
              readonly name: string;
              readonly status: {
                readonly value: MemberStatusValue;
              } | null;
              readonly " $fragmentSpreads": FragmentRefs<"UserHandle_member">;
            };
          } | null;
        }>;
      };
    };
    readonly vault?: {
      readonly members: ReadonlyArray<{
        readonly avatar: {
          readonly name: string | null;
          readonly url: URIString;
        } | null;
        readonly id: string;
        readonly name: string;
        readonly status: {
          readonly value: MemberStatusValue;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"UserHandle_member">;
      }>;
    };
  } | null;
};
export type ReminderModal_node_Query = {
  response: ReminderModal_node_Query$data;
  variables: ReminderModal_node_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v8 = [
  (v3/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "status",
    "plural": false,
    "selections": [
      (v7/*: any*/)
    ],
    "storageKey": null
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "UserHandle_member"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Member",
  "kind": "LinkedField",
  "name": "member",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "SignatureEnvelope",
  "kind": "LinkedField",
  "name": "signatureEnvelope",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SignaturesConnection",
      "kind": "LinkedField",
      "name": "signatures",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SignatureEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Signature",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v4/*: any*/),
                (v9/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rsvp",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "EventInvitationConnection",
  "kind": "LinkedField",
  "name": "invitations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventInvitationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventInvitation",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v12/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Member",
              "kind": "LinkedField",
              "name": "invitee",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SpaceMembershipConnection",
      "kind": "LinkedField",
      "name": "memberships",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SpaceMembershipEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SpaceMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v9/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = [
  (v3/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "status",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v7/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "roles",
    "storageKey": null
  }
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Member",
  "kind": "LinkedField",
  "name": "member",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "SignatureEnvelope",
  "kind": "LinkedField",
  "name": "signatureEnvelope",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SignaturesConnection",
      "kind": "LinkedField",
      "name": "signatures",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SignatureEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Signature",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v4/*: any*/),
                (v16/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = [
  (v3/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "EventInvitationConnection",
  "kind": "LinkedField",
  "name": "invitations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventInvitationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventInvitation",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v12/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Member",
              "kind": "LinkedField",
              "name": "invitee",
              "plural": false,
              "selections": (v15/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SpaceMembershipConnection",
      "kind": "LinkedField",
      "name": "memberships",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SpaceMembershipEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SpaceMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v16/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReminderModal_node_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Vault",
                "kind": "LinkedField",
                "name": "vault",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Member",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": true,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "VaultItem",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormResponseConnection",
                        "kind": "LinkedField",
                        "name": "responses",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormResponseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormResponse",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Member",
                                    "kind": "LinkedField",
                                    "name": "responder",
                                    "plural": false,
                                    "selections": (v8/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Form",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "ownershipEvent",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              (v14/*: any*/)
            ],
            "type": "FolderItem",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "type": "Event",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReminderModal_node_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Vault",
                "kind": "LinkedField",
                "name": "vault",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Member",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": true,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "VaultItem",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormResponseConnection",
                        "kind": "LinkedField",
                        "name": "responses",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormResponseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormResponse",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Member",
                                    "kind": "LinkedField",
                                    "name": "responder",
                                    "plural": false,
                                    "selections": (v15/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Form",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v18/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v18/*: any*/),
                    "type": "PendingFile",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "ownershipEvent",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              (v20/*: any*/)
            ],
            "type": "FolderItem",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v19/*: any*/),
              (v20/*: any*/)
            ],
            "type": "Event",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "02c6913bbc16ea39ba452aa4937d3e3e",
    "id": null,
    "metadata": {},
    "name": "ReminderModal_node_Query",
    "operationKind": "query",
    "text": "query ReminderModal_node_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    id\n    ... on VaultItem {\n      signatureEnvelope {\n        id\n        status\n        signatures {\n          edges {\n            node {\n              id\n              status\n              member {\n                id\n                name\n                avatar {\n                  name\n                  url\n                }\n                status {\n                  __typename\n                  value\n                }\n                ...UserHandle_member\n              }\n            }\n          }\n        }\n      }\n      vault {\n        members {\n          id\n          name\n          avatar {\n            name\n            url\n          }\n          status {\n            __typename\n            value\n          }\n          ...UserHandle_member\n        }\n        id\n      }\n    }\n    ... on FolderItem {\n      signatureEnvelope {\n        id\n        status\n        signatures {\n          edges {\n            node {\n              id\n              status\n              member {\n                id\n                name\n                avatar {\n                  name\n                  url\n                }\n                status {\n                  __typename\n                  value\n                }\n                ...UserHandle_member\n              }\n            }\n          }\n        }\n      }\n      content {\n        __typename\n        ... on Form {\n          __typename\n          responses {\n            edges {\n              node {\n                id\n                state\n                responder {\n                  id\n                  name\n                  avatar {\n                    name\n                    url\n                  }\n                  status {\n                    __typename\n                    value\n                  }\n                  ...UserHandle_member\n                }\n              }\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on PendingFile {\n          id\n        }\n      }\n      ownershipEvent {\n        id\n        invitations {\n          edges {\n            node {\n              id\n              rsvp\n              invitee {\n                id\n                name\n                avatar {\n                  name\n                  url\n                }\n                status {\n                  __typename\n                  value\n                }\n                ...UserHandle_member\n              }\n            }\n          }\n        }\n      }\n      space {\n        memberships {\n          edges {\n            node {\n              id\n              member {\n                id\n                name\n                avatar {\n                  name\n                  url\n                }\n                status {\n                  __typename\n                  value\n                }\n                ...UserHandle_member\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n    ... on Event {\n      invitations {\n        edges {\n          node {\n            id\n            rsvp\n            invitee {\n              id\n              name\n              avatar {\n                name\n                url\n              }\n              status {\n                __typename\n                value\n              }\n              ...UserHandle_member\n            }\n          }\n        }\n      }\n      space {\n        memberships {\n          edges {\n            node {\n              id\n              member {\n                id\n                name\n                avatar {\n                  name\n                  url\n                }\n                status {\n                  __typename\n                  value\n                }\n                ...UserHandle_member\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar {\n    url\n  }\n}\n\nfragment UserHandle_member on Member {\n  id\n  name\n  email\n  ...UserAvatar_member\n  ...UserInfoPopover_member\n}\n\nfragment UserInfoPopover_member on Member {\n  id\n  name\n  email\n  roles\n  ...UserAvatar_member\n}\n"
  }
};
})();

(node as any).hash = "c5a984d82f5eaf63e98fabb1b43e9d6d";

export default node;
